import React, { useState } from 'react'
import { Breadcrumbs, DynamicEntityIndex } from '@reactiveonline/reactive_admin_shared-packages'
import GlobalImports from '../shared/GlobalImports'
import { dynamicTableItemRenderer } from '@reactiveonline/reactive_admin_shared-packages/utils'

export default function Index({
  appProps, accounts, accountPlans, breadcrumbs, entityPath, exportAccountsPath, icon, initialTotalPages, listColumns, selectedColumns, initialCount
}) {
  const [hoveredItem, setHoveredItem] = useState({ type: '', id: null })

  const filters = [
    {
      key: 'flavour',
      title: 'Flavour',
      type: 'select',
      options: ['Shop', 'Ordering', 'Appointment', 'Travel'].map(item => (
        {
          title: Support.translations.module_names[item.toLowerCase()],
          value: item
        }
      ))
    },
    {
      key: 'plan',
      title: 'Plan',
      type: 'select',
      options: accountPlans.map(item => (
        {
          title: item,
          value: item
        }
      ))
    },
    {
      key: 'status',
      title: 'Status',
      type: 'select',
      options: ['Active', 'Canceled', 'Pending'].map(item => (
        {
          title: item,
          value: item
        }
      ))
    },
    {
      key: 'invoicing_software_status',
      title: 'Invoice Software Status',
      type: 'select',
      options: [0, 10, 20, 30, 40, 50, 60].map(item => (
        {
          title: ReactiveCore.translations.invoicing_onboarding.status[item],
          value: item
        }
      ))
    },
    {
      key: 'registration_origin',
      title: 'Registration Origin',
      type: 'select',
      options: ["Direct", "Partners"].map(item => (
        {
          title: item,
          value: item
        }
      ))
    },
    {
      key: 'payment_type',
      title: 'Payment Type',
      type: 'select',
      options: ["Card", "IBAN", "external_payment"].map(item => (
        {
          title: item,
          value: item
        }
      ))
    },
  ]

  const itemRenderer = (item, columns) => {
    return (
      <>
        { columns.map(column => {
          if (column.label == 'name') {
            return (
              <div key={ column.label } className='item flex-1'>
                <a href={ `${ entityPath }/${ item.apiUid }` }>
                  { item[column.label] }
                </a>
              </div>
            )
          } else if(['email', 'domain'].includes(column.label)) {
            const exceedsLength = item[column.label].length > 30

            return (
              <div
                key={ column.label }
                className='item flex-1'
                onMouseEnter={ _e => setHoveredItem({ type: column.label, id: item.id })}
                onMouseLeave={ _e => setHoveredItem({ type: '', id: null })}
                style={{ position: 'relative' }}
              >
                <div>
                  { exceedsLength ? item[column.label].slice(0, 27) + '...' : item[column.label] }
                </div>

                { exceedsLength && hoveredItem.type === column.label && hoveredItem.id === item.id &&
                  <div
                    className='flex-box items-center p-r-10'
                    style={{ position: 'absolute', backgroundColor: 'rgba(255, 255, 255, 1)', zIndex: 99999, height: '100%' }}
                  >
                    { item[column.label] }
                  </div>
                }
              </div>
            )
          } else {
            return dynamicTableItemRenderer(item, column)
          }
        })}
      </>
    )
  }

  return (
    <>
      <div className='page-wrapper-header'>
        <div style={{ width: '100%' }}>
          <div className='flex-box items-center content-space-between'>
            <div className='page-header'>
              <i className={ `fa-light ${ icon }`} />
              <h1 className='page-header-title'>
                { Support.translations.account.plural }
              </h1>
            </div>
          </div>

          <Breadcrumbs
            breadcrumbs={ breadcrumbs }
            wrapperHeader={ false }
          />
        </div>
      </div>

      <DynamicEntityIndex
        initialItems={ accounts }
        initialTotalPages={ initialTotalPages }
        initialTotalCount={ initialCount }
        fetchOnStart
        disableDelete={ true }
        entity={ 'accounts' }
        filters={ filters }
        tabs={ [] }
        tableHeadings={ selectedColumns }
        itemRenderer={ itemRenderer }
        itemsPath={ entityPath }
        icon={ icon }
        noResourcesTitle={ Support.translations.account.no_accounts }
        listColumns={ listColumns }
        columnTranslations={ Support.translations.columns }
        isExportable
        exportPath={ exportAccountsPath }
        restrictPastDates
        minDateRange={ 730 }
        enableDateFilter
        selectAll
        headline={ Support.translations.account.plural }
        initialDatesEmpty
      />

      <GlobalImports appProps={ appProps } />
    </>
  )
}
